module.exports = {
    "<3"  : "heart",
    ":o)" : "monkey_face",
    ":*"  : "kiss",
    ":-*" : "kiss",
    "<\/3": "broken_heart",
    "=)"  : "smiley",
    "=-)" : "smiley",
    "C:"  : "smile",
    "c:"  : "smile",
    ":D"  : "smile",
    ":-D" : "smile",
    ":>"  : "laughing",
    ":->" : "laughing",
    ";)"  : "wink",
    ";-)" : "wink",
    "8)"  : "sunglasses",
    ":|"  : "neutral_face",
    ":-|" : "neutral_face",
    ":\\" : "confused",
    ":-\\": "confused",
    ":\/" : "confused",
    ":-\/": "confused",
    ":p"  : "stuck_out_tongue",
    ":-p" : "stuck_out_tongue",
    ":P"  : "stuck_out_tongue",
    ":-P" : "stuck_out_tongue",
    ":b"  : "stuck_out_tongue",
    ":-b" : "stuck_out_tongue",
    ";p"  : "stuck_out_tongue_winking_eye",
    ";-p" : "stuck_out_tongue_winking_eye",
    ";b"  : "stuck_out_tongue_winking_eye",
    ";-b" : "stuck_out_tongue_winking_eye",
    ";P"  : "stuck_out_tongue_winking_eye",
    ";-P" : "stuck_out_tongue_winking_eye",
    "):"  : "disappointed",
    ":("  : "disappointed",
    ":-(" : "disappointed",
    ">:(" : "angry",
    ">:-(": "angry",
    ":'(" : "cry",
    "D:"  : "anguished",
    ":o"  : "open_mouth",
    ":-o" : "open_mouth",
    ":O"  : "open_mouth",
    ":-O" : "open_mouth",
    ":)"  : "slightly_smiling_face",
    "(:"  : "slightly_smiling_face",
    ":-)" : "slightly_smiling_face"
}



// WEBPACK FOOTER //
// ./components/TextDisplay/textToAliases.js